/**
 * Vms Api Factory
 */

import { AuthenticatedRequestor } from '@solink/vd-data-layer/api-clients/shared/AuthenticatedRequestor';
import { VmsApi as VmsApiClient } from '@solink/vd-data-layer/api-clients/vms/vms';

import settings from '@solinkcorp/settings';
import * as constants from 'vd-constants';
import AuthService from '../models/AuthService';

/**
 * Create a new VMS API instance with the provided auth token.
 */
function VmsApi(deviceUrl: string, cloudOnly: boolean, authToken: string): VmsApiClient;

/**
 * Create a new VMS API instance.
 * @deprecated Pass in auth token when creating a new instance.
 */
function VmsApi(deviceUrl: string, cloudOnly?: boolean): VmsApiClient;

function VmsApi(deviceUrl: string, cloudOnly = false, token?: string): VmsApiClient {
  const authToken = token ?? AuthService.authToken;

  if (!authToken) {
    throw new Error(`Can't make VMS API requests when not logged in.`);
  }

  return new VmsApiClient(
    new AuthenticatedRequestor(deviceUrl, constants.REQUEST_TIMEOUT, authToken, false),
    cloudOnly,
    settings.cloud_vms_host,
  );
}

export default VmsApi;
